import { useApi } from '@omnipresentgroup/api';
import { useQuery } from '@tanstack/react-query';

const API_BASE = process.env.OMNIPLATFORM_API;
const API_PATH = 'invoices/kolleno';

type QueryParameters = {
  companyId: string;
  enabled?: boolean;
};

export const useKollenoGenerateURL = ({
  companyId,
  enabled,
}: QueryParameters) => {
  const { GET } = useApi();

  const query = useQuery({
    queryKey: [API_PATH, companyId],
    queryFn: () =>
      GET<{ url: string }>(
        `${API_BASE}/${API_PATH}`,
        {},
        {
          companyId: `${companyId}`,
        },
      ),
    enabled: enabled || !!companyId,
  });

  return query;
};
